import React from 'react'
import Skeleton from 'react-loading-skeleton'

const TimelineSkeleton = () => {

    return (
        <div>
            <div className='w-100 px-md-0'>
                <div id='tracking'>
                    <div className='tracking-list'>
                        {Array(8).fill(null).map((_, index) => (
                            <div
                                className={`tracking-item ${index === 0 ? 'pt-0' : ''} ${index === 3 ? 'pb-0' : ''}`}
                                key={index}
                            >
                                <div className='tracking-icon status-intransit mt-n4'>
                                    <Skeleton
                                        baseColor='var(--kt-skeleton-bg-color)'
                                        highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                        circle
                                        width={35}
                                        height={35} />
                                </div>
                                <div className='tracking-date font-size-13 fw-semibold d-md-block d-none'>
                                    <Skeleton
                                        baseColor='var(--kt-skeleton-bg-color)'
                                        highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                        width={`100%`}
                                        height={34} />
                                </div>
                                <div className='tracking-date font-size-13 fw-semibold d-md-none d-block'>
                                    <Skeleton
                                        baseColor='var(--kt-skeleton-bg-color)'
                                        highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                        width={`100%`}
                                        height={20} />
                                </div>
                                <div className='bg-white p-4 rounded d-md-block d-none'>
                                    <div className=' font-size-13 fw-semibold'>
                                        <Skeleton
                                            baseColor='var(--kt-skeleton-bg-color)'
                                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                            width={`100%`}
                                            height={30} />
                                    </div>
                                </div>
                                <div className='bg-white pt-4 rounded d-md-none d-block'>
                                    <div className='tracking-content font-size-13 fw-semibold'>
                                        <Skeleton
                                            baseColor='var(--kt-skeleton-bg-color)'
                                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                            width={`100%`}
                                            height={50} />
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default TimelineSkeleton
